// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RegionSelector_wrapper__jOwuk","title":"RegionSelector_title__QJfk3","options":"RegionSelector_options__grZIQ"};